<template>
  <div :class="`divider divider--${paddingSize} w-100`" />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    paddingSize: {
      type: String,
      default: 'medium',
      validator: size => {
        return ['small', 'medium', 'large'].indexOf(size) !== -1
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.divider {
  height: 1px;
  background: #c3c3c3;
}

.divider--small {
  margin-top: 10px;
  margin-bottom: 10px;
}

.divider--medium {
  margin-top: 16px;
  margin-bottom: 16px;
}

.divider--large {
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>
